import HotelStatusIcon from 'components/HotelStatusIcon'
import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import Toggle from 'components/ReusableComponents/Toggle'
import useCopyText from 'hooks/useCopyText'
import { hotelStatusColors, hotelStatusNames } from 'main/hotelStatuses'
import moment from 'moment'
import { useState } from 'react'
import subsidiariesApi from 'services/api/subsidiaries'
import canadianProvinces from 'static/addresses/canadianProvinces'
import usStates from 'static/addresses/usStates'

import { ReactComponent as CopyIcon } from './copyIcon.svg'
import styles from './Hotels.module.scss'

export const HotelCard = ({
  updateResults,
  groupName,
  hotelName,
  bookingEngine,
  chainCode,
  parentChainCode,
  addedOn,
  updatedOn,
  id,
  pms,
  displayId,
  status,
  city,
  stateCode,
  inviteBlockOn
}) => {
  const inviteBackIsDisabled = inviteBlockOn

  const inviteBackDisabledBy = inviteBlockOn?.addedBy
  const inviteBackDisabledOn = inviteBlockOn?.addedOn
  const inviteBackDisableReason = inviteBlockOn?.reason

  const copy = useCopyText()

  const [isToggleAutoInviteDialogVisible, setIsToggleAutoInviteDialogVisible] =
    useState(false)

  const [autoInviteDisableReason, setAutoInviteDisableReason] = useState('')

  function handleAutoInviteToggleChange() {
    if (inviteBackIsDisabled) {
      subsidiariesApi.enableAutoInvite({ subsidiaryId: id }).then(() => {
        updateResults(id)
      })
    } else {
      setIsToggleAutoInviteDialogVisible(true)
    }
  }

  return (
    <div className={styles.cardParent}>
      {isToggleAutoInviteDialogVisible && (
        <ConfirmationDialog
          maxWidth={800}
          title={hotelName}
          hasDangerousAction={true}
          positiveMessage="Disable invite campaigns"
          negativeMessage="Cancel"
          isButtonDisabled={autoInviteDisableReason.length < 3}
          onReject={() => {
            setIsToggleAutoInviteDialogVisible(false)
            setAutoInviteDisableReason('')
          }}
          onConfirm={() => {
            subsidiariesApi
              .disableAutoInvite({
                subsidiaryId: id,
                reason: autoInviteDisableReason
              })
              .then(() => {
                setIsToggleAutoInviteDialogVisible(false)
                updateResults(id)
              })
          }}
        >
          <TextInput
            label="Reason for disabling"
            value={autoInviteDisableReason}
            style={{ width: 500 }}
            onChangeValue={setAutoInviteDisableReason}
          />
        </ConfirmationDialog>
      )}
      <div className={styles.titleGroup}>
        <div className={styles.hotelName}>
          <div className={styles.statusIcon}>
            <HotelStatusIcon status={status} />
          </div>
          <div className={styles.name}>
            <span className={styles.displayId}>#{displayId}</span>
            <span className={styles.hotelNameItself}>{hotelName}</span>
            <span className={styles.groupNameItself}>{groupName}</span>
            <span className={styles.bullet}>&#8226;</span>
          </div>
          <div className={styles.infoToCopy}>
            <button onClick={() => copy(id, 'hotel id')}>
              <CopyIcon />
              Copy id
            </button>
          </div>
          <span className={styles.status}>
            <span
              className={styles.statusDot}
              style={{ backgroundColor: hotelStatusColors[status] }}
            ></span>
            {hotelStatusNames[status]}
          </span>
        </div>
      </div>
      <div className={styles.hotelCard}>
        <div className={styles.bookingEngine}>
          <span>{bookingEngine}</span>
          <span>{pms}</span>
        </div>
        <div className={styles.chainCode}>
          <span>{chainCode}</span>
          <span>{parentChainCode}</span>
        </div>
        <div className={styles.addedOn}>
          <span>{moment(addedOn).format('MMM DD, YYYY')}</span>
          <span>{moment(addedOn).format('hh:mm')}</span>
        </div>
        <div className={styles.lastUpdated}>
          <span>{moment(updatedOn).format('MMM DD, YYYY')}</span>
          <span>{moment(updatedOn).format('hh:mm')}</span>
        </div>
        <div className={styles.lastUpdated}>
          <span>{city}</span>
        </div>
        <div className={styles.lastUpdated}>
          <span>{{ ...usStates, ...canadianProvinces }?.[stateCode]}</span>
        </div>
        <div
          className={styles.ctaCol}
          data-tip={
            inviteBackIsDisabled
              ? `Disabled by ${inviteBackDisabledBy} on ${moment(
                  inviteBackDisabledOn
                ).format('YYYY-MM-DD')} because "${inviteBackDisableReason}"`
              : null
          }
        >
          <Toggle
            label="Auto invite"
            checked={!inviteBackIsDisabled}
            handleChange={handleAutoInviteToggleChange}
          />
        </div>
      </div>
    </div>
  )
}
